import { Ref, ref } from "vue";
import { AVError } from "@/business/shared/commons/AVError";

const defaultError: AVError = {
  error: {
    error: "",
  },
};

export function errorManagerActions() {
  function transform(error: string): string {
    const message: Ref<string> = ref("");

    try {
      const errorJson = JSON.parse(JSON.stringify(error));
      const messageError = JSON.parse(errorJson.detail);
      message.value = JSON.stringify(messageError.error);
    } catch (e) {
      message.value = error.toString().substr(6);
    }

    return message.value;
  }

  function transformAV(error: string): AVError {
    const avError: Ref<AVError> = ref(defaultError);
    avError.value = JSON.parse(JSON.stringify(error));

    return avError.value;
  }

  function createError(error: string): AVError {
    return {
      error: {
        error: error,
      },
    };
  }

  return {
    transform,
    transformAV,
    createError,
  };
}
